module.exports = __webpack_public_path__ + "static/media/vitality_home.98b7fe74.jpeg";